import {
  PAGE,
  SECTION_PAGE_PRODUCT,
  SECTION_PAGE_CONTENT,
  SECTION_PAGE_CONTENT_ITEM,
  SECTION_PAGE_ALBUM,
  SECTION_PAGE_ALBUM_ITEM,
  SECTION_PAGE_TERMS_CONDITION,
  SECTION_PAGE_PRODUCT_BRAND,
  SECTION_PAGE_GIFTCARD,
  SECTION_PAGE_INFORM_PAYMENT,
  SECTION_PAGE_PRODUCT_ITEM,
  SECTION_PAGE_FORM_ITEM,
  SECTION_PAGE_ONLINE_PAYMENT,
  SECTION_PAGE_CONTACT,
  SECTION_PAGE_ORDER_TRACKING,
  SECTION_PAGE_FAQ,
  SECTION_PAGE_EVENT_CALENDAR,
  SECTION_PAGE_EVENT_CALENDAR_ITEM,
  SECTION_PAGE_POLICY,
  SECTION_PAGE_QUOTATION_FORM_ITEM,
  SECTION_PAGE_SEARCH,
} from "@model/components/componentMeta.model";
import { genUniqKey } from "@helpers/component.helper";
import { replaceDeep } from "@helpers/object.helper";
import { contactTextDefault } from "@model/components/contactText.model";
import { createWidgetText } from "@model/components/systemText.model";
import { createWidgetMap } from "@model/components/systemMap.model";
import { createWidgetImage } from "@model/components/systemImage.model";

// SITE > Page
const createSitePage = (customID, pageType = null, customComponent = {}, siteComponents) => {
  const id = customID ? customID : genUniqKey(siteComponents, PAGE.prefixKey);
  let component = {
    type: PAGE.type,
    id: id,
    version : "1.3",
    properties: {
      groupType: (pageType === null || pageType === '') ? null : (pageType == 'section' ? 'custom' : 'system'),
      type: (pageType === null || pageType === '') ? null : pageType,
      name: "",
      url: "",
      isEnable: true,
      metaDataID: null,
      seo: {
        title: '',
        description: '',
        keywords: [],
        focusKeyword: [],
      },
      canonical: {
        url: null,
        language: null,
        type: null,
        id: null,
      },
      permission: {
        type: 'public',
        password: '',
        passwordPageTitle: '',
        passwordPageSubtitle: '',
        passwordPageButton: '',
        memberType: 'all',
        memberGroupsID: []
      },
      tags: []
    },
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};

// PAGE
const createPage = (customID, pageType = null, customComponent = {}, siteComponents) => {
  const id = customID ? customID : genUniqKey(siteComponents, PAGE.prefixKey);
  const groupType = (pageType === null || pageType === '') ? null : (pageType == 'section' ? 'custom' : 'system');
  let componentsID = [];
  let components = {};
  let propertiesData = {};
  let styleData = {};
  let data = {};

  if (pageType == 'contact') {
    // SectionPage
    const systemSection = createSectionPage(pageType);
    components[systemSection.id] = systemSection;
    componentsID.push(systemSection.id);

    // Text
    const contactText = contactTextDefault()
    const systemTextComp = createWidgetText(contactText)
    components[systemSection.id].componentsID.push(systemTextComp.key);
    components[systemTextComp.key] = systemTextComp.object[systemTextComp.key];

    // Map
    const systemMapComp = createWidgetMap()
    components[systemSection.id].componentsID.push(systemMapComp.key);
    components[systemMapComp.key] = systemMapComp.object[systemMapComp.key];

    // Image
    const systemImageComp = createWidgetImage();
    components[systemSection.id].componentsID.push(systemImageComp.key);
    components[systemImageComp.key] = systemImageComp.object[systemImageComp.key];

  } else if (pageType != 'section') {
    // SectionPage
    const systemSection = createSectionPage(pageType);
    components[systemSection.id] = systemSection;
    componentsID.push(systemSection.id);
  }

  let component = {
    props: {
      type: "PAGE",
      id: id,
      version : 1.1,
      properties: {
        type: pageType,
        groupType: groupType,
      },
      components: {
        CONTENT_CONTAINER: {
          type: "CONTENT_CONTAINER",
          componentsID: componentsID,
        },
      },
    },
    assets: {
      components: components,
      propertiesData: propertiesData,
      styleData: styleData,
      data: data,
    },
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};

// PAGE > SectionPage
const createSectionPage = (pageType = 'custom', customComponent = {}) => {
  switch (pageType) {
    case 'section':
      return null;
    case 'product_list':
      return createSectionPageProduct(customComponent);
    case 'content_list':
      return createSectionPageContent(customComponent);
    case 'content_item':
      return createSectionPageContentItem(customComponent);
    case 'album_list':
      return createSectionPageAlbum(customComponent);
    case 'album_item':
      return createSectionPageAlbumItem(customComponent);
    case 'terms_condition':
      return createSectionPageTermsCondition(customComponent);
    case 'product_brand':
      return createSectionPageProductBrand(customComponent);
    case 'giftcard_list':
      return createSectionPageGiftcard(customComponent);
    case 'inform_payment':
      return createSectionPageInformpayment(customComponent);
    case 'product_item':
      return createSectionPageProductItem(customComponent);
    case 'form_item':
      return createSectionPageFormItem(customComponent);
    case 'online_payment':
      return createSectionPageOnlinePayment(customComponent);
    case 'contact':
      return createSectionPageContact(customComponent);
    case 'order_tracking':
      return createSectionPageOrderTracking(customComponent);
    case 'faq':
      return createSectionPageFAQ(customComponent);
    case 'event_calendar':
      return createSectionPageEventCalendar(customComponent);
    case 'event_calendar_item':
      return createSectionPageEventCalendarItem(customComponent);
    case 'policy':
      return createSectionPagePolicy(customComponent);
    case 'quotation_form_item':
      return createSectionPageQuotationFormItem(customComponent);
    case 'search':
        return createSectionPageSearch(customComponent);
    default:
      return null;
  }
};
const createSectionPageAlbum = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_ALBUM.type,
    id: SECTION_PAGE_ALBUM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      categoryID: null,
      sortBy: null,
      numItem: 24,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageAlbumItem = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_ALBUM_ITEM.type,
    id: SECTION_PAGE_ALBUM_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      categoryID: null,
      albumID: null,
      sortBy: null,
      numItem: 20,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageContent = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_CONTENT.type,
    id: SECTION_PAGE_CONTENT.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      type: 'category',
      categoryID: null,
      sortBy: 'recently',
      contentDisplay: 20,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageContentItem = (customComponent = {}) => {


  let component = {
    type: SECTION_PAGE_CONTENT_ITEM.type,
    id: SECTION_PAGE_CONTENT_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      categoryID: null,
      contentID: null,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageProduct = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_PRODUCT.type,
    id: SECTION_PAGE_PRODUCT.staticKey,
    properties: {},
    style: {},
    data: {
      type: 'category', // category, brand, best_seller, flash_sale
      categoryID: { 
        level1: '0', 
        level2: null, 
        level3: null, 
        level4: null, 
      },
      brandID: null,
      promotionType: null,
      promotionID: null,
      dateRange: null,
      sortBy: null,
      numItem: 20,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageProductItem = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_PRODUCT_ITEM.type,
    id: SECTION_PAGE_PRODUCT_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      categoryID: { 
        level1: null, 
        level2: null, 
        level3: null, 
        level4: null, 
      },
      productID: null,
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
}
const createSectionPageProductBrand = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_PRODUCT_BRAND.type,
    id: SECTION_PAGE_PRODUCT_BRAND.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      brandsDisplay: 20
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageGiftcard = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_GIFTCARD.type,
    id: SECTION_PAGE_GIFTCARD.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      type: "giftcard_list",
      categoryID: "0", //Category GiftCard
      dateRange: null,
      sortBy: null,
      numItem: 20
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageFormItem = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_FORM_ITEM.type,
    id: SECTION_PAGE_FORM_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      formID: null
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
}
const createSectionPageInformpayment = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_INFORM_PAYMENT.type,
    id: SECTION_PAGE_INFORM_PAYMENT.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageOnlinePayment = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_ONLINE_PAYMENT.type,
    id: SECTION_PAGE_ONLINE_PAYMENT.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
}
const createSectionPageOrderTracking = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_ORDER_TRACKING.type,
    id: SECTION_PAGE_ORDER_TRACKING.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageFAQ = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_FAQ.type,
    id: SECTION_PAGE_FAQ.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      type : "all_category",
      sortType : "recently",
      categoryID : '0',
      faqDisplay : 10
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageContact = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_CONTACT.type,
    id: SECTION_PAGE_CONTACT.staticKey,
    version: '1.2',
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      detail: {
        address: null,
        tel: null,
        email: null,
      },
      map: {
        googleMap: {
          branchSinglePlaceID: "ChIJVcnkZsqe4jAR25oqSvNv03o",
          branchSingleAddress: "128/328 ชั้น 30 อาคาร, พญาไท พลาซ่า ถ. พญาไท แขวง ทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400, Thailand",
          branchMultiple : [
            {
              branchID : 1,
              logo : "",
              logoID : "",
              description : "Description detail",
              name : "Default Location",
              longitude : 100.5318088,
              latitude : 13.7564798,
              address : "128/323-333 ชั้น 30 Payatai Plaza, Phaya Thai Rd, Khwaeng Thung Phaya Thai, Khet Ratchathewi, Krung Thep Maha Nakhon 10400, Thailand",
              directionLink : "https://maps.google.com/?cid=8850540783425198811",
              isOpenInfo : true
            }
          ],
          branchMultipleID : [1],
          center : {
            lat : 13.7564798,
            lng : 100.5318088
          },
        },
        imageMap: {
            imageType: 'website',
            imageID: null,
            imageUrl: null,
            imageName: null,
            imageTitle: null,
            imageAlt: null,
            imageWidth: null,
            imageHeight: null,
        },
      },
    },
    componentsID: [],
  } 
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageTermsCondition = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_TERMS_CONDITION.type,
    id: SECTION_PAGE_TERMS_CONDITION.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageEventCalendar = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_EVENT_CALENDAR.type,
    id: SECTION_PAGE_EVENT_CALENDAR.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};
const createSectionPageEventCalendarItem = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_EVENT_CALENDAR_ITEM.type,
    id: SECTION_PAGE_EVENT_CALENDAR_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};

const createSectionPagePolicy = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_POLICY.type,
    id: SECTION_PAGE_POLICY.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      policyType: null
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};

const createSectionPageQuotationFormItem = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_QUOTATION_FORM_ITEM.type,
    id: SECTION_PAGE_QUOTATION_FORM_ITEM.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {
      quotationFormId: null
    }
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
}

const createSectionPageSearch = (customComponent = {}) => {
  let component = {
    type: SECTION_PAGE_SEARCH.type,
    id: SECTION_PAGE_SEARCH.staticKey,
    properties: {
      isEnable: true
    },
    style: {},
    data: {}
  };
  return customComponent ? replaceDeep(component, customComponent) : component;
};

export default {
  createSitePage,
  createPage,
  createSectionPage,
};
